<template>
  <div class="card">
    <div class="card-header">
      <strong class="text-success">{{ $t('dashboardCompany.irktLvhsi') }}</strong>
    </div>
    <div class="card-body">
      <div
        v-for="(a,i) in companyBoard"
        :key="i"
        class="mb-3"
      >
        <div class="d-flex justify-content-start align-items-center">
          <img
            class="rounded-circle img-thumbnail"
            :src="getPhoto(a.user.photo,'thumbnailCropped')"
            alt=""
            style="width: 50px;"
          >

          <div class="ml-3">
            <strong>
              {{ a.user.name }} {{ a.user.surname }}
            </strong>
            {{ actionLocalization(a.action) }}

            <br>
            <div class="text-secondary">
              {{ $t('dashboardCompany.key', {moment: getMoment(a.logTime)}) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <router-link
        :to="{name: 'companyBoard'}"
        class="btn btn-sm btn-light-primary"
      >
        {{ $t('dashboardCompany.dahaOxGstr') }}
      </router-link>
    </div>
  </div>
</template>
<script>
import {actionLocalization, getPhoto} from "@/repositories/Utils";
import {getCompanyBoard} from "@/repositories/GeneralDataRepository";
import {mapState} from "vuex";
import moment from "moment";

export default {
  name: 'DashboardCompanyBoard',
  data() {
    return {
      companyBoard: []
    };
  },

  computed: {
    ...mapState({
      token: state => state.auth.token,
    })
  },
  mounted() {

    getCompanyBoard(this.token).then(data => {
      if (data.code === 200) {

        this.companyBoard = data.data.slice(0, Math.min(data.data.length, 5));
      }
    })
  },
  methods: {
    getMoment(time) {
      moment(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    actionLocalization(action) {
      return actionLocalization(action);
    },
  }
}
</script>
<style scoped>

@keyframes blink {
  50% {
    opacity: 0.2;
  }
}

@-webkit-keyframes blink {
  50% {
    opacity: 0.2;
  }
}

</style>